import { ADD_ITEM_ANALYSES, ADD_QUIZ_ANALYSIS, QUIZ_ANALYSIS_NOT_FOUND, ITEM_ANALYSIS_NOT_FOUND, TOGGLE_ITEM_ANALYSIS_EXPANDED } from '@instructure/quiz-common';
export function addItemAnalyses(itemAnalyses) {
  return {
    type: ADD_ITEM_ANALYSES,
    payload: itemAnalyses
  };
}
export function addQuizAnalysis(quizAnalysis) {
  return {
    type: ADD_QUIZ_ANALYSIS,
    payload: quizAnalysis
  };
}
export function markQuizAnalysisNotFound(quizId) {
  return {
    type: QUIZ_ANALYSIS_NOT_FOUND,
    payload: quizId
  };
}
export function markItemAnalysisNotFound(itemId) {
  return {
    type: ITEM_ANALYSIS_NOT_FOUND,
    payload: itemId
  };
}
export function toggleItemAnalysisRowExpanded(itemId) {
  return {
    payload: itemId,
    type: TOGGLE_ITEM_ANALYSIS_EXPANDED
  };
}